// extracted by mini-css-extract-plugin
export default {"main":"styles_main__GOU0r","header":"styles_header__KTCk3","title":"styles_title__Bgigj","tabs":"styles_tabs__6ZOdB"};